import React from "react";
import Svg, { Path, G } from "react-native-svg";
import { TouchableOpacity } from "react-native";

import AppTheme from "../../../AppTheme";

export default function MoreIcon(props) {
  const width = props.width || 20;
  const height = props.height || 20;
  const fillColor = props.color || AppTheme.DEFAULT_COLOR;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G opacity="0.8">
          <Path
            d="M6.81822 17.0454C7.94789 17.0454 8.86368 16.1297 8.86368 15C8.86368 13.8703 7.94789 12.9545 6.81822 12.9545C5.68855 12.9545 4.77277 13.8703 4.77277 15C4.77277 16.1297 5.68855 17.0454 6.81822 17.0454Z"
            fill={fillColor}
          />
          <Path
            d="M15 17.0454C16.1297 17.0454 17.0455 16.1297 17.0455 15C17.0455 13.8703 16.1297 12.9545 15 12.9545C13.8704 12.9545 12.9546 13.8703 12.9546 15C12.9546 16.1297 13.8704 17.0454 15 17.0454Z"
            fill={fillColor}
          />
          <Path
            d="M23.1819 17.0454C24.3115 17.0454 25.2273 16.1297 25.2273 15C25.2273 13.8703 24.3115 12.9545 23.1819 12.9545C22.0522 12.9545 21.1364 13.8703 21.1364 15C21.1364 16.1297 22.0522 17.0454 23.1819 17.0454Z"
            fill={fillColor}
          />
        </G>
      </Svg>
    </TouchableOpacity>
  );
}
